// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__iAvpF","inputWrap":"Table_inputWrap__aE7Yc","col":"Table_col__rr81L","bmiTooltip":"Table_bmiTooltip__13D2q"};